// import React from "react";
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import InputMask from 'react-input-mask';
import CepPromise from 'cep-promise';
import axios from 'axios';

import Swal from 'sweetalert2'


import {
    ContainerInformation,
    ContainerInformacoes,
    ContainerCarrinho,
    P1, P2, P3, P4, P5, P6, P7, P8, P9, P10, P11,
    StyledInput,
    StyledInputMobile,
    StyledInput2,
    StyledInputEmail,
    StyledSelect,
    BoxForm,
    NavCaminho,
    FlexContato,
    NavContaLoginFlex,
    InputCheckbox,
    BoxCheckbox,
    FlexTable,
    FlexTableMobile,
    ContainerInputs,
    OptionStyled,
    ButtonContinuarCompra,
    ButtonContinuarCompraMobile,
    FlexPolitica,
    FlexBack,
    FlexSecure,
    VoltarFlex,
    VoltarFlexMobile,
    BoxCarrinho,
    CartInformacao,
    ContinuarMobile,
    CartFrete,
    BoxInformacoesUsuarioFrete,
    BoxBorder,
    FlexFrete,
    FlexFreteMobile,
    FlexFrete2,
    FlexFrete3,
    FlexFrete4,
    FlexFrete5,
    BoxInformacoesUsuarioFrete2,
    P12, P13, P14, P15, P16,
    LabelCircle,
    InputCircle,
    SpanCircle,
    ContainerRolagem
} from './Information.style.js';
import {
    CarrinhoMain, CardP, ImgCardP, ContainerCardp, ContainerProduto, DadosProduto, NomeProduto,
    ContainerValoresP, UnidadeP, VezesP, ValorP, ContainerRemover
} from './Home.style.js';
import Maior from '../components/svg/maior.svg';
import Back from '../components/svg/back.svg';
import ExcluirSvg from '../components/svg/excluir.svg';

import BaronTechSegura from '../components/assets/BaronTechSegura.png';
import GoogleLojaSegura from '../components/assets/GoogleLojaSegura.png';
import Loading from '../components/assets/loading.gif';

import apiService from "../api/home.js";



import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function InformationPage() {
    const navigate = useNavigate();

    const handleBackClick = () => {
        navigate(-1); // Isso vai voltar à última página visitada
    };

    //Divs Visiveis

    const [isFreteVisible, setIsFreteVisible] = useState(false);
    const [loading, setLoading] = useState(false);
    const [frete, setFrete] = useState("");
    const [precos_fretes, setPrecosFretes] = useState([]);
    const [selectedIndex, setSelectedIndex] = useState(null);



    const [ItensCarrinho, setItensCarrinho] = useState([]);
    const estadosBrasil = [
        "AC", "AL", "AP", "AM", "BA", "CE", "DF", "ES", "GO", "MA", "MT", "MS", "MG", "PA",
        "PB", "PR", "PE", "PI", "RJ", "RN", "RS", "RO", "RR", "SC", "SP", "SE", "TO"
    ];


    const [estado, setEstado] = React.useState("");






    // Estado para campos do endereço
    const [cep, setCep] = useState('');
    const [nome, setNome] = useState('');
    const [sobrenome, setSobrenome] = useState('');
    const [telefone, setTelefone] = useState('');
    const [bairro, setBairro] = useState('');
    const [rua, setRua] = useState('');
    const [numero, setNumero] = useState('');
    const [complemento, setComplemento] = useState('');
    const [cidade, setCidade] = useState('');
    const [pais, setPais] = useState('');
    const [cpf, setCpf] = useState('');


    useEffect(() => {
        atualizarCarrinho()
    }, []);

    useEffect(() => {
        atualizarPrecoFrete()
    }, [selectedIndex]);


    useEffect(() => {
        verificarLogado()
    }, []);

    const atualizarPrecoFrete = async () => {
        var getPrecos = precos_fretes[selectedIndex];
        console.log('getPrecos', getPrecos)

        if (getPrecos == null || getPrecos == undefined) {
            return false
        }

        setFrete("" + getPrecos.custom_price)
    }

    const verificarLogado = async () => {
        localStorage.removeItem('_voltar_checkout')

        var get_idusuario = await localStorage.getItem('@idusuario')

        if (get_idusuario == null || get_idusuario == '') {
            localStorage.setItem('_voltar_checkout', 's')
            navigate('/account')
            return false
        }
    }

    function converterParaReal(valor) {
        // Garantir que o valor é um número
        if (isNaN(valor)) {
            return "Valor inválido";
        }

        // Formatar o número para o padrão brasileiro
        const valorFormatado = parseFloat(valor).toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL'
        });

        return valorFormatado;
    }



    const atualizarCarrinho = async (status) => {
        setItensCarrinho([])
        atualizarRenderCarrinho()
    }




    const handleButtonClick = async () => {


        //validar dados

        var idusuario = await localStorage.getItem('@idusuario')

        if (idusuario == null || idusuario == '') {
            navigate('account')
        }

        idusuario = btoa(idusuario);



        if (nome == null || nome == '') {
            toast.error('Nome inválido');
            return false
        }

        if (sobrenome == null || sobrenome == '') {
            toast.error('Sobrenome inválido');
            return false
        }

        if (telefone == null || telefone == '') {
            toast.error('Telefone inválido');
            return false
        }

        if (cep == null || cep == '') {
            toast.error('CEP inválido');
            return false
        }


        if (cpf == null || cpf == '') {
            toast.error('CPF inválido');
            return false
        }

        if (frete == null || frete == '') {
            toast.error('Digite  um CEP válido e selecione um frete');
            return false
        }


        if (bairro == null || bairro == '') {
            toast.error('Bairro inválido');
            return false
        }

        if (rua == null || rua == '') {
            toast.error('Rua inválido');
            return false
        }

        if (numero == null || numero == '') {
            toast.error('Número inválido');
            return false
        }


        if (estado == null || estado == '') {
            toast.error('Estado inválido');
            return false
        }


        if (cidade == null || cidade == '') {
            toast.error('Cidade inválido');
            return false
        }







        var getAmbiente = apiService.ambiente();

        const dominio = apiService.obterDominio();

        var get_dados_carrinho = await localStorage.getItem('@carrinho')

        get_dados_carrinho = JSON.parse(get_dados_carrinho)

        var endpoint = getAmbiente + '/integracao/venda/inserir.php'

        var getArrayFrete = precos_fretes[selectedIndex];

        var valorFrete = parseInt(frete) // REMOVA quando resolver o bug do valor do frete

        const total = somarTotalValue(ItensCarrinho)

        if (total >= 300) {
            valorFrete = 0
        }

        const data = JSON.stringify(
            {
                "idusuario": idusuario,
                "dominio": dominio,
                "cep": cep,
                "endereco": rua,
                "numero": numero,
                "complemento": complemento,
                "bairro": bairro,
                "cidade": cidade,
                "uf": estado,
                "frete": valorFrete,
                "frete_escolhido": getArrayFrete,
                "produtos": get_dados_carrinho
            }
        );




        const config = {
            method: 'post',
            url: endpoint,
            headers: {
                'Content-Type': 'application/json'
            },
            data: data
        };

        setLoading(true)
        try {
            const response = await axios.request(config);
            var dados = response.data;
            console.log('INSERIR_VENDA', dados)


            if (dados.erro == "S") {
                alert(dados.mensagem)
                return false
            }

            Swal.fire({
                title: 'Sucesso!',
                text: dados.mensagem,
                icon: 'success',
            }).then(() => {
                setLoading(false)

                localStorage.removeItem('@carrinho')
                window.atualizarCarrinho();

                window.location.href = dados.checkout;
            })

        } catch (error) {
            setLoading(false)
            console.log('Erro ao chamar a API:', error);
            alert("COD 1149 - Aconteceu um problema, tente novamente!")
        }


    };


    function sleep(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    const atualizarRenderCarrinho = async () => {

        var get_dados_carrinho = await localStorage.getItem('@carrinho')

        if (get_dados_carrinho == null || get_dados_carrinho == '') {
            get_dados_carrinho = '[]'
        }

        get_dados_carrinho = JSON.parse(get_dados_carrinho)

        if (get_dados_carrinho.length == 0) {

            await sleep(1500)
            navigate('/')
        }

        console.log('get_dados_carrinho', get_dados_carrinho)
        setItensCarrinho(get_dados_carrinho)
    }


    const calcularFrete = async () => {



        //validar dados

        var idusuario = await localStorage.getItem('@idusuario')

        if (idusuario == null || idusuario == '') {
            navigate('account')
        }

        idusuario = btoa(idusuario);


        var getAmbiente = apiService.ambiente();

        //provisoriamente depois de atualizar o banco atualizar
        getAmbiente = "https://dev.barontechsistemas.com.br";


        const dominio = apiService.obterDominio();

        var get_dados_carrinho = await localStorage.getItem('@carrinho')

        get_dados_carrinho = JSON.parse(get_dados_carrinho)

        var endpoint = getAmbiente + '/integracao/melhorenvio/cotacaofrete.php'

        var input_cep = document.getElementById("input_cep").value

        const data = JSON.stringify(
            {
                "idusuario": idusuario,
                "dominio": dominio,
                "cep": input_cep,
                "produtos": get_dados_carrinho
            }
        );




        const config = {
            method: 'post',
            url: endpoint,
            headers: {
                'Content-Type': 'application/json'
            },
            data: data
        };

        try {
            const response = await axios.request(config);
            var dados = response.data;
            console.log('DADOS_FRETES', dados)

            if (dados.erros == null) {

                const total = somarTotalValue(ItensCarrinho)

                if (total >= 300) {
                    setSelectedIndex(0)
                }

                if (dados && dados.length > 0) {
                    setPrecosFretes(dados)
                }
            }

        } catch (error) {

            console.log('Erro ao chamar a API:', error);
            alert("COD 1155 - Aconteceu um problema, tente novamente!")
        }


    }

    const fetchAddress = async (cepValue) => {
        try {
            const address = await CepPromise(cepValue);
            setBairro(address.neighborhood || '');
            setRua(address.street || '');
            setCidade(address.city || '');
            setEstado(address.state || '');
            setPais('Brasil');

            calcularFrete()

        } catch (error) {
            console.error('Erro ao buscar o CEP:', error);
            // Você pode definir mensagens de erro aqui se desejar
        }
    };

    function renderImg(item) {
        const getAmbiente = apiService.ambiente();

        var imgPrincipal = item.urlfotoprincipal;

        if (item.urlfotoprincipal == null || item.urlfotoprincipal == null) {
            if (item.fotos && item.fotos.length > 0) {
                imgPrincipal = item.fotos[0].urlfoto
            }
        }

        var get_item_url = imgPrincipal;
        var url = getAmbiente + "/" + get_item_url

        return url

    }

    const handleCepChange = async (event) => {
        const value = event.target.value;
        setCep(value);

        if (value.length === 9) {
            await fetchAddress(value);
        }
    };

    const somarTotal = (item) => {

        let total = 0;

        for (let i = 0; i < item.length; i++) {
            const produto = item[i];
            const preco = parseFloat(produto.preco.replace(",", "."));
            total += preco * produto.quantidade;
        }

        return total.toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL',
        });

    }

    const somarTotalValue = (item) => {

        let total = 0;

        for (let i = 0; i < item.length; i++) {
            const produto = item[i];
            const preco = parseFloat(produto.preco.replace(",", "."));
            total += preco * produto.quantidade;
        }

        return total;

    }


    const clickExcluir = async (index) => {
        // Recupera o carrinho existente no localStorage
        const carrinho = JSON.parse(localStorage.getItem('@carrinho')) || [];

        // Verifica se o índice é válido
        if (index >= 0 && index < carrinho.length) {
            // Remove o item do carrinho pelo índice
            carrinho.splice(index, 1);

            // Atualiza o localStorage com o carrinho atualizado
            localStorage.setItem('@carrinho', JSON.stringify(carrinho));
            console.log('Item removido com sucesso!');
            atualizarCarrinho()

            toast.error('Item removido do carrinho!', {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
        } else {
            console.error('Índice inválido. Nenhum item foi removido.');
        }
    }

    const somarTotalFrete = (item) => {

        let total = 0;

        for (let i = 0; i < item.length; i++) {
            const produto = item[i];
            const preco = parseFloat(produto.preco.replace(",", "."));
            total += preco * produto.quantidade;
        }

        console.log('total', total)

        if (total < 300) {
            total = total + parseFloat(frete.replace(",", "."));// + FRETE 
        } else {
            total = total
        }

        return total.toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL',
        });

    }
    return (
        <ContainerInformation>
            <ContainerRolagem>
                <ContainerInformacoes>
                    <BoxForm>
                        <div>
                            {/* <P1>Logo</P1> */}
                            {/* <NavCaminho>
                                <P2>Carrinho</P2>
                                <img src={Maior} />
                                <P2>Informações</P2>
                                <img src={Maior} />
                                <P9 active={isFreteVisible}>Frete</P9>

                            </NavCaminho> */}
                        </div>

                        <ContinuarMobile style={{ display: 'flex', width: '100%' }}>

                            {/* Informacao */}
                            <CartInformacao style={{ display: isFreteVisible ? 'none' : 'block' }}>
                                <ContainerInputs>
                                    {/* <FlexContato>
                                    <div><P3>Contato</P3></div>
                                    <NavContaLoginFlex><P10>Tem uma conta?</P10><P11>Fazer login</P11></NavContaLoginFlex>
                                </FlexContato> */}
                                    <div>
                                        {/* <FlexTable>
                                        <StyledInputEmail placeholder="E-mail"></StyledInputEmail>
                                    </FlexTable> */}
                                        <div>
                                            {/* <BoxCheckbox>
                                            <InputCheckbox type="checkbox" id="item1"></InputCheckbox>
                                            <P6 for="item1">Enviar novidades e ofertas para mim por e-mail</P6>
                                        </BoxCheckbox>
                                        <BoxCheckbox>
                                            <InputCheckbox type="checkbox" id="item2"></InputCheckbox>
                                            <P6 for="item2">Quero receber descontos e novidades por WhatsApp</P6>
                                        </BoxCheckbox> */}
                                        </div>
                                    </div>
                                </ContainerInputs>
                                <ContainerInputs id="dados_entrega">
                                    <P3>Endereço de entrega</P3>
                                    <div>
                                        <FlexTable>
                                            <StyledInput
                                                type="text"
                                                placeholder="Nome"
                                                value={nome}
                                                onChange={(e) => setNome(e.target.value)}
                                                autoComplete="given-name"
                                            />
                                            <StyledInput
                                                type="text"
                                                placeholder="Sobrenome"
                                                value={sobrenome}
                                                onChange={(e) => setSobrenome(e.target.value)}
                                                autoComplete="family-name"
                                            />
                                        </FlexTable>
                                        <FlexTableMobile>
                                            <InputMask
                                                mask="(99)99999-9999"
                                                value={telefone}
                                                onChange={(e) => setTelefone(e.target.value)}
                                                placeholder="Nº de celular"
                                                maskChar={null}
                                            >
                                                {(inputProps) => <StyledInputMobile {...inputProps} type="tel" autoComplete="tel" />}
                                            </InputMask>
                                            <InputMask
                                                mask="99999-999"
                                                value={cep}
                                                onChange={handleCepChange}
                                                placeholder="CEP"
                                                id="input_cep"
                                                maskChar={null}
                                            >
                                                {(inputProps) => <StyledInputMobile {...inputProps} type="text" autoComplete="postal-code" />}
                                            </InputMask>
                                        </FlexTableMobile>
                                        <FlexTable>
                                            <StyledInput
                                                type="text"
                                                placeholder="CPF / CNPJ"
                                                value={cpf}
                                                onChange={(e) => setCpf(e.target.value)}
                                                autoComplete="cpf"
                                            />
                                            <StyledInput
                                                type="text"
                                                placeholder="Bairro"
                                                value={bairro}
                                                onChange={(e) => setBairro(e.target.value)}
                                                autoComplete="address-level2"
                                            />
                                        </FlexTable>
                                        <FlexTableMobile>
                                            <StyledInputMobile
                                                type="text"
                                                placeholder="Rua"
                                                value={rua}
                                                onChange={(e) => setRua(e.target.value)}
                                                autoComplete="address-line1"
                                            />
                                            <StyledInput2
                                                type="text"
                                                placeholder="N.º"
                                                value={numero}
                                                onChange={(e) => setNumero(e.target.value)}
                                                autoComplete="address-line2"
                                            />
                                        </FlexTableMobile>
                                        <FlexTable>
                                            <StyledSelect
                                                value={estado}
                                                onChange={(e) => setEstado(e.target.value)}
                                                autoComplete="address-level1"
                                            >
                                                <option value="" disabled>
                                                    Selecione um estado
                                                </option>
                                                {estadosBrasil.map((estado) => (
                                                    <option key={estado} value={estado}>
                                                        {estado}
                                                    </option>
                                                ))}
                                            </StyledSelect>
                                            <StyledInput
                                                type="text"
                                                placeholder="Cidade"
                                                value={cidade}
                                                onChange={(e) => setCidade(e.target.value)}
                                                autoComplete="address-level2"
                                            />
                                        </FlexTable>
                                        <FlexTable>

                                            <StyledInput
                                                type="text"
                                                placeholder="Complemento (Opcional)"
                                                value={complemento}
                                                onChange={(e) => setComplemento(e.target.value)}
                                                autoComplete="address-line2"
                                            />
                                            {/* <StyledSelect 
                                            value={pais}
                                            onChange={(e) => setPais(e.target.value)}
                                        >
                                            <OptionStyled value="">País / Região</OptionStyled>
                                            <OptionStyled value="br">Brasil</OptionStyled>
                                            <OptionStyled value="us">Estados Unidos</OptionStyled>
                                            <OptionStyled value="fr">França</OptionStyled>
                                        </StyledSelect> */}
                                        </FlexTable>

                                        <FlexBack>
                                            <VoltarFlex onClick={handleBackClick}><img src={Back} /><P4>Voltar ao carrinho</P4></VoltarFlex>
                                            <div>

                                                {loading == false && (<ButtonContinuarCompra onClick={handleButtonClick}>
                                                    <P5 >Continuar</P5>
                                                </ButtonContinuarCompra>)}

                                                {loading == true && (<ButtonContinuarCompra>
                                                    <img style={{ width: 20, height: 20 }} src={Loading} />
                                                </ButtonContinuarCompra>)}
                                            </div>
                                        </FlexBack>
                                    </div>
                                </ContainerInputs>
                            </CartInformacao>
                            {/* Informacao */}

                            {/* Frete */}
                            <CartFrete style={{ display: isFreteVisible ? 'block' : 'none' }}>
                                <BoxInformacoesUsuarioFrete>
                                    <BoxBorder style={{ borderBottom: '1px solid #E6E6E6' }}>
                                        <FlexFreteMobile>
                                            <P12>Contato</P12>
                                            <P16>nettoschueng@gmail.com</P16>
                                            <P13>Alterar</P13>
                                        </FlexFreteMobile>
                                    </BoxBorder>
                                    <BoxBorder>
                                        <FlexFrete>
                                            <P12>Enviar para</P12>
                                            <P16>168.210.867-88, Rua Abiail do Amaral Carneiro, 85 - Enseada do Suá, Apt 1501, 29050-535 Vitória ES, Brasil</P16>
                                            <P13>Alterar</P13>
                                        </FlexFrete>
                                    </BoxBorder>
                                </BoxInformacoesUsuarioFrete>

                                <div>
                                    <P3 style={{ marginTop: 30, marginBottom: 24 }}>Forma de frete</P3>
                                    <BoxInformacoesUsuarioFrete2>
                                        <FlexFrete2 style={{ borderBottom: '1px solid #D9D9D9' }}>
                                            <FlexFrete3>
                                                <LabelCircle className="checkbox-container">
                                                    <InputCircle type="checkbox" />
                                                    <SpanCircle className="checkmark"></SpanCircle>
                                                </LabelCircle>
                                                <FlexFrete4>
                                                    <P14 style={{ margin: 0 }}>Frete 01</P14>
                                                    <P15 style={{ margin: 0 }}>7 dias úteis</P15>
                                                </FlexFrete4>
                                            </FlexFrete3>
                                            <FlexFrete5>
                                                <P13 style={{ margin: 0 }}>R$ 10,78</P13>
                                            </FlexFrete5>
                                        </FlexFrete2>

                                        <FlexFrete2 style={{ borderBottom: '1px solid #D9D9D9' }}>
                                            <FlexFrete3>
                                                <LabelCircle className="checkbox-container">
                                                    <InputCircle type="checkbox" />
                                                    <SpanCircle className="checkmark"></SpanCircle>
                                                </LabelCircle>
                                                <FlexFrete4>
                                                    <P14 style={{ margin: 0 }}>Frete 01</P14>
                                                    <P15 style={{ margin: 0 }}>7 dias úteis</P15>
                                                </FlexFrete4>
                                            </FlexFrete3>
                                            <FlexFrete5>
                                                <P13 style={{ margin: 0 }}>R$ 10,78</P13>
                                            </FlexFrete5>
                                        </FlexFrete2>

                                        <FlexFrete2 style={{ borderBottom: '1px solid #D9D9D9' }}>
                                            <FlexFrete3>
                                                <LabelCircle className="checkbox-container">
                                                    <InputCircle type="checkbox" />
                                                    <SpanCircle className="checkmark"></SpanCircle>
                                                </LabelCircle>
                                                <FlexFrete4>
                                                    <P14 style={{ margin: 0 }}>Frete 01</P14>
                                                    <P15 style={{ margin: 0 }}>7 dias úteis</P15>
                                                </FlexFrete4>
                                            </FlexFrete3>
                                            <FlexFrete5>
                                                <P13 style={{ margin: 0 }}>R$ 10,78</P13>
                                            </FlexFrete5>
                                        </FlexFrete2>

                                        <FlexFrete2 style={{ borderBottom: '1px solid #D9D9D9' }}>
                                            <FlexFrete3>
                                                <LabelCircle className="checkbox-container">
                                                    <InputCircle type="checkbox" />
                                                    <SpanCircle className="checkmark"></SpanCircle>
                                                </LabelCircle>
                                                <FlexFrete4>
                                                    <P14 style={{ margin: 0 }}>Frete 01</P14>
                                                    <P15 style={{ margin: 0 }}>7 dias úteis</P15>
                                                </FlexFrete4>
                                            </FlexFrete3>
                                            <FlexFrete5>
                                                <P13 style={{ margin: 0 }}>R$ 10,78</P13>
                                            </FlexFrete5>
                                        </FlexFrete2>

                                        <FlexFrete2>
                                            <FlexFrete3>
                                                <LabelCircle className="checkbox-container">
                                                    <InputCircle type="checkbox" />
                                                    <SpanCircle className="checkmark"></SpanCircle>
                                                </LabelCircle>
                                                <FlexFrete4>
                                                    <P14 style={{ margin: 0 }}>Frete 01</P14>
                                                    <P15 style={{ margin: 0 }}>7 dias úteis</P15>
                                                </FlexFrete4>
                                            </FlexFrete3>
                                            <FlexFrete5>
                                                <P13 style={{ margin: 0 }}>R$ 10,78</P13>
                                            </FlexFrete5>
                                        </FlexFrete2>
                                    </BoxInformacoesUsuarioFrete2>
                                </div>
                            </CartFrete>
                            {/* Frete */}

                            {/* CARRINHO */}
                            <ContainerCarrinho id="carrinho_compras" >
                                <BoxCarrinho style={{ height: 600 }}>
                                    <P1 style={{ marginBottom: 25 }}>Carrinho de compras</P1>

                                    {ItensCarrinho.length == 0 && (
                                        <>
                                            <div style={{ justifyContent: 'center', display: 'flex', marginTop: 20 }}>
                                                <ValorP >Seu carrinho está vázio</ValorP>
                                            </div>
                                        </>
                                    )}

                                    <div style={{ borderBottom: 'solid 1px #D2D2D2', width: '100%', overflowY: 'scroll', }}>

                                        {ItensCarrinho.map((i, index) => {
                                            return (
                                                <CardP style={{ margin: 0, padding: 0, marginBottom: 25 }}>
                                                    <ImgCardP ><img style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: 5, minWidth: 30 }} src={renderImg(i)} /></ImgCardP>
                                                    <ContainerCardp style={{ width: '100%', justifyContent: 'space-between', marginLeft: 20 }}>
                                                        <ContainerProduto>
                                                            <DadosProduto>
                                                                <NomeProduto>{i.tituloloja}</NomeProduto>
                                                                <ContainerValoresP>
                                                                    <UnidadeP>{i.quantidade}</UnidadeP>
                                                                    <VezesP>X</VezesP>
                                                                    <ValorP>R$ {i.preco}</ValorP>
                                                                </ContainerValoresP>
                                                            </DadosProduto>
                                                        </ContainerProduto>
                                                        <ContainerRemover onClick={() => clickExcluir(index)}>
                                                            <img src={ExcluirSvg} alt="Excluir" />
                                                        </ContainerRemover>
                                                    </ContainerCardp>
                                                </CardP>
                                            )
                                        })}



                                    </div>

                                    <div style={{ padding: '30px 0', width: '100%', borderBottom: 'solid 1px #D2D2D2' }}>
                                        <FlexTable style={{ marginBottom: 0 }}>
                                            <StyledInput type="text" style={{ borderRadius: 5 }} placeholder="+ Aplicar código de cupom"></StyledInput>
                                            <ButtonContinuarCompra style={{ padding: '12px 20px' }}><P5 style={{ fontSize: 12, margin: 0 }} onClick={() => {
                                                alert("Cupom inválido!")
                                            }}>Aplicar</P5></ButtonContinuarCompra>
                                        </FlexTable>
                                    </div>

                                    <div style={{ padding: '30px 0', width: '100%', borderBottom: 'solid 1px #D2D2D2' }}>
                                        <FlexContato>
                                            <div><P11 style={{ margin: 0, marginBottom: 10 }}>Total</P11></div>
                                            <NavContaLoginFlex><P11 style={{ margin: 0, marginBottom: 10 }}>{somarTotal(ItensCarrinho)}</P11></NavContaLoginFlex>
                                        </FlexContato>
                                        <FlexContato>
                                            <div><P11 style={{ margin: 0, marginBottom: 10 }}>Frete:</P11></div>
                                        </FlexContato>
                                        <FlexContato>
                                            {/* <div><P11  style={{margin:0, marginBottom:10}}>Taxa</P11></div> */}
                                            {/* <NavContaLoginFlex><P11  style={{margin:0, marginBottom:10}}>R$3,00</P11></NavContaLoginFlex> */}
                                        </FlexContato>
                                        <FlexContato>
                                            {/* <div><P11 style={{ margin: 0, marginBottom: 10 }}>Frete</P11></div> */}
                                            {/* <NavContaLoginFlex><P6 style={{ margin: 0, marginBottom: 10, color: '#848484' }}>Calculado na próxima etapa</P6></NavContaLoginFlex> */}
                                            {/* <NavContaLoginFlex><P6 style={{ margin: 0, marginBottom: 10, color: '#848484' }}>R$ {frete}</P6></NavContaLoginFlex> */}
                                            <div style={{
                                                width: '100%',
                                                display: 'flex',
                                                height: 100,
                                                backgroundColor: '#ebebeb',
                                                overflowY: 'scroll',
                                                flexDirection: 'column',
                                                justifyContent: somarTotalValue(ItensCarrinho) >= 300 ? 'center' : null
                                            }}>

                                                {somarTotalValue(ItensCarrinho) >= 300 ?
                                                    <div style={{
                                                        display: 'flex',
                                                        justifyContent: 'center'
                                                    }}>
                                                        <text>Frete Grátis</text>
                                                    </div>
                                                    :
                                                    <>
                                                        {precos_fretes.map((item, index) => {

                                                            if (item.custom_price == null) {
                                                                return (<></>)
                                                            }

                                                            return (
                                                                <div style={{ height: 400, marginBottom: 10 }}>
                                                                    <div style={{ backgroundColor: selectedIndex === index ? "lightblue" : "white", height: 30, padding: 4, marginBottom: 1, alignItems: 'center', display: 'flex', cursor: 'pointer', borderRadius: 5 }}
                                                                        onClick={() => setSelectedIndex(index)}
                                                                    >
                                                                        <img src={item.company.picture} style={{ width: 50, height: 10, objectFit: 'cover' }}></img>  <span style={{ color: 'black', fontWeight: 'bold', marginLeft: 20 }}>{item.name}  -  {converterParaReal(item.custom_price)}</span>
                                                                    </div>
                                                                </div>
                                                            )
                                                        })}
                                                    </>
                                                }
                                            </div>
                                        </FlexContato>
                                    </div>

                                    <div style={{ padding: '30px 0', width: '100%' }}>
                                        <FlexContato>
                                            <div><P11>Subtotal</P11></div>
                                            {frete != '' && (<NavContaLoginFlex>
                                                <P6 style={{ margin: 0, fontSize: 32, fontWeight: 600, color: '#000' }}>
                                                    {somarTotalFrete(ItensCarrinho)}
                                                </P6>
                                            </NavContaLoginFlex>)}
                                        </FlexContato>
                                    </div>

                                </BoxCarrinho>
                            </ContainerCarrinho>
                            {/* CARRINHO */}

                            {loading == false && (<ButtonContinuarCompraMobile style={{ marginBottom: 100 }} onClick={handleButtonClick} >
                                <P5>Continuar</P5>
                            </ButtonContinuarCompraMobile>)}

                            {loading == true && (<ButtonContinuarCompraMobile style={{ marginBottom: 100 }} >
                                <img style={{ width: 20, height: 20 }} src={Loading} />
                            </ButtonContinuarCompraMobile>)}



                        </ContinuarMobile>




                        <div>
                            <FlexPolitica>
                                <P7>Política de frete</P7>
                                <P7>Política de privacidade</P7>
                                <P7>Termos de serviço</P7>
                                <P7>Política de reembolso</P7>
                            </FlexPolitica>
                            <div>
                                <div>
                                    <P8>Certificados</P8>
                                    <FlexSecure>
                                        <img style={{ width: 60.667, height: 30.05 }} src={BaronTechSegura} />
                                        <img style={{ width: 70, height: 23.81, marginLeft: 10, border: 'solid 1px #77B5E0' }} src={GoogleLojaSegura} />
                                    </FlexSecure>
                                </div>
                            </div>
                        </div>
                    </BoxForm>
                </ContainerInformacoes>
            </ContainerRolagem>

        </ContainerInformation>
    );
}

export default InformationPage;
